import { flatMap } from 'lodash';
import React from 'react';
import { TTimeStepOption } from '../../../api/endpoints/SubsetOption';
import { MatrixEditor } from '../../Ui/MatrixEditor';
import SelectAllControl from "../SelectAllControl";

export type TTimeStepValue = {
  step: string;
  time: number;
}

const timeStepsToOptions = (spec: TTimeStepOption): Array<TTimeStepValue> => {
  const { step, time } = spec.value;

  return flatMap(time, (timeItem, index) => {
    const stepRanges = step[index];

    return stepRanges.map(stepRange => {
      const [start, end] = stepRange.split('-').map(v => parseInt(v, 10))

      return ({
        time: parseInt(timeItem, 10),
        step: [start, end].join('-')
      });
    });
  });
}

const columnLabel = (option: TTimeStepValue) => option.time.toString();
const rowLabel = (option: TTimeStepValue) => option.step;

const TimeStepSelector = (props: {
  values: Array<TTimeStepValue>;
  spec: TTimeStepOption;
  onChange: (values: Array<TTimeStepValue>) => void;
}) => {
  const { spec, values, onChange } = props;

  const options = timeStepsToOptions(spec);

  return (
    <div>
      <SelectAllControl onChange={onChange} values={options} className="margin-bottom-xs" />

      <MatrixEditor
        options={options}
        selection={values}
        setSelection={onChange}
        optionToColumn={columnLabel}
        optionToRow={rowLabel}
        renderColumn={c => <span>{c}</span>}
        needsFocus={false}
        acknowledgeFocusRequest={() => undefined}
      />
    </div>
  );
};

export default TimeStepSelector;
